import React, { useContext } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { PageContext } from '@xingternal/pages-common';

import styles from './UpsellBanner.css';
import Icon from './images/upsell_icon_purple.png';
import { getMarketingPageUrl } from './utils';

type UpsellBannerWithIconProps = {
  headerCopyKey: string;
  bodyCopyKey: string;
  moduleName: string;
};

const UpsellBannerWithIcon = ({
  headerCopyKey,
  bodyCopyKey,
  moduleName,
}: UpsellBannerWithIconProps) => {
  const intl = useIntl();
  const { pageContext } = useContext(PageContext);

  const marketingPageUrl = getMarketingPageUrl({
    locale: intl.locale,
    moduleName,
    focusType: pageContext?.focusType,
  });

  return (
    <div className={styles.premiumWrapperWithIcon}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <span className={styles.flag}>
            <FormattedMessage id="EP_FLAG_EMPLOYER_BRANDING_PROFILE" />
          </span>
          <div className={styles.headerText}>
            <Headline size="xlarge">
              <FormattedMessage id={headerCopyKey} />
            </Headline>
          </div>
          <BodyCopy className={styles.text}>
            <FormattedMessage id={bodyCopyKey} />
          </BodyCopy>
        </div>
        <div className={styles.premiumButtonMargin}>
          <Button
            size="medium"
            variant="proBusiness"
            className={styles.premiumButton}
            href={marketingPageUrl}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <FormattedMessage id="EP_UPSELL_GALLERY_BUTTON" />
          </Button>
        </div>
      </div>
      <img className={styles.icon} src={Icon} alt="Upsell icon purple" />
    </div>
  );
};

export default UpsellBannerWithIcon;
